import React, { Component } from 'react';
import {
    Container,
    Card,
    CardHeader, CardBody,
    Input,
    Button,
    Row,
    Col,
    Collapse
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';

class ImportContacts extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);

        this.batchLimit = 100;

        this.state = {
            data: [],
            results: null,
            isDone: false,
            inputFile: '',
            error: '',
            open: (this.props.open !== undefined) ? this.props.open : false,
            notesCategories: []
        };

    }

    componentDidMount() {
        this.getNotesCategories();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getNotesCategories = () => {
        fetch('/api/notesCategories/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    notesCategories: results.data.filter(item => item.type === 'Contact')[0].children,
                });
            });
        return;
    }

    normalizeNotesCategory = (input, inputCategory) => {
        if (!input) return null;

        const category = this.state.notesCategories.find(item => item.type.toLowerCase() === inputCategory.toLowerCase())
        if (!category) return input;
        if (category.multiline) {
            const answerArray = input.split(',').map(item => item.trim());
            const newArray = [];
            answerArray.forEach(answer => {
                const foundList = category.list.find(item => item.description.toLowerCase() === answer.toLowerCase());
                if (foundList) {
                    newArray.push(foundList.ID)
                }
            })
            return newArray;
        } else {
            const foundList = category.list.find(item => item.description.toLowerCase() === input.toLowerCase());
            if (foundList) {
                return String(foundList.ID);
            }
        }

        return input;
    }

    normalizeDate = (input) => {
        if (!input) return null;

        // Case 1: Already in yyyy-mm-dd from <input type="date">
        const isoPattern = /^\d{4}-\d{2}-\d{2}$/;
        if (isoPattern.test(input)) return input;

        // Try to parse any common format
        const parsed = new Date(input);
        if (isNaN(parsed)) return null;

        // Format to yyyy-mm-dd
        const y = parsed.getFullYear();
        const m = String(parsed.getMonth() + 1).padStart(2, "0");
        const d = String(parsed.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    normalizePhone = (input) => {
        if (!input) return null;

        // Remove all non-digit characters
        const digits = input.replace(/\D/g, "");

        // Handle 10-digit numbers (standard U.S.)
        if (digits.length === 10) {
            return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        }

        // Handle leading 1 for country code
        if (digits.length === 11 && digits.startsWith("1")) {
            return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
        }

        // Otherwise invalid or unsupported format
        return input;
    }

    parseCSVLine = (line) => {
        const result = [];
        let currentField = "";
        let insideQuotes = false;

        for (let char of line) {
            if (char === '"' && insideQuotes) {
                insideQuotes = false; // Closing a quoted field
            } else if (char === '"' && !insideQuotes) {
                insideQuotes = true; // Opening a quoted field
            } else if (char === "," && !insideQuotes) {
                result.push(currentField); // End of field
                currentField = "";
            } else {
                currentField += char; // Append character to the current field
            }
        }

        result.push(currentField); // Add the last field
        return result.map((field) => (field.startsWith('"') && field.endsWith('"') ? field.slice(1, -1) : field)); // Remove surrounding quotes
    };

    handleUpload = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        this.setState({
            inputFile: file
        }, () => {
            const reader = new FileReader();

            reader.onload = (e) => {
                const text = e.target.result;

                const rows = text.split("\n").map((line) => {
                    return this.parseCSVLine(line); // Custom function to handle quoted fields
                });

                const [headers, ...dataRows] = rows;
                const data = dataRows.map((row) => {
                    return headers.reduce((acc, header, index) => {
                        acc[header.trim()] = row[index]?.trim();
                        return acc;
                    }, {});
                });

                let dataArray = [];
                data.forEach(item => {
                    if (!item['Contact Name']) {
                        return;
                    }
                    let contactIndex = (dataArray.findIndex(contactArr => contactArr.contactName === item['Contact Name'] && contactArr.emailAddress === item['Email Address']));
                    if (contactIndex === -1) {
                        dataArray.push({
                            contactName: item['Contact Name'],
                            title: item['Title'],
                            phoneNumber: this.normalizePhone(item['Phone Number']),
                            phoneNumberOffice: this.normalizePhone(item['Phone Number (Office)']),
                            phoneNumberMobile: this.normalizePhone(item['Phone Number (Mobile)']),
                            phoneNumberPersonal: this.normalizePhone(item['Phone Number (Personal)']),
                            phoneNumberHome: this.normalizePhone(item['Phone Number (Home)']),
                            emailAddress: item['Email Address'],
                            emailAddressOffice: item['Email Address (Office)'],
                            emailAddressPersonal: item['Email Address (Personal)'],
                            linkedInURL: item['LinkedIn URL'],
                            birthday: this.normalizeDate(item['Birthday']),
                            gender: this.normalizeNotesCategory(item['Gender'], 'Gender'),
                            almaMater: item['Alma Mater'],
                            hobbies: item['Hobbies'],
                            otherPersonalDetails: item['Other Personal Details'],
                            preferredMethodOfContact: this.normalizeNotesCategory(item['Preferred Method of Contact'], 'Preferred Method of Contact'),
                            contactType: this.normalizeNotesCategory(item['Contact Type'], 'Contact Type'),
                            note: item['Note'],
                            secNumber: item['Company Number'],
                            companyName: item['Company Name'],
                        })
                    }
                })

                this.setState({
                    data: dataArray,
                    incompleteCompanies: []
                }, () => {
                    this.insertData(dataArray);
                })
            };
            reader.readAsText(file);
        })
    }

    insertData(dataArray, incompleteCompanies) {
        fetch('/api/import/contacts/', {
            method: 'POST',
            body: JSON.stringify({
                data: dataArray,
                incompleteCompanies
                // table: [...this.props.available_dates].pop()?.date_key
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results?.debug_message?.error != null) {
                    this.setState({
                        isDone: true,
                        results: null,
                        error: 'Unable to fully process uploaded file'
                    })
                    return;
                };
                this.setState({
                    isDone: true,
                    results: results
                })
            })
            .catch(reason => {
                this.setState({
                    isDone: true,
                    results: null,
                    error: 'Unable to process uploaded file'
                })
            })

    }

    resetUpload = () => {
        this.setState({
            data: [],
            isDone: false,
            inputFile: '',
            results: null,
            error: ''
        })
    }

    finishUpload = () => {
        this.insertData(this.state.data, this.state.results.incompleteCompanies.filter(item => item.secNumber !== '' && item.companyName !== ''))
    }

    changeIncompleteCompany = (value, index, prop) => {
        this.setState((prev) => {
            const incompleteCompanies = prev.results.incompleteCompanies;
            incompleteCompanies[index][prop] = value;
            return {
                results: { incompleteCompanies, maxSecNumber: prev.results.maxSecNumber }
            }
        })
    }

    autoGenerate = (index) => {
        const max = (Number(this.state.results?.maxSecNumber || 0)) + 10;
        this.setState((prev) => {
            const incompleteCompanies = prev.results.incompleteCompanies;
            incompleteCompanies[index].secNumber = '999-' + max;
            return {
                results: { incompleteCompanies, maxSecNumber: max }
            }
        })
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        let duplicates = false;
        if (this.state.results?.incompleteCompanies) {
            duplicates = [...this.state.results.incompleteCompanies].filter(item => item.secNumber !== '')
                .map(i => i.secNumber)
                .filter((v, i, a) => a.indexOf(v) !== i);
        }
        return (
            <Container fluid>
                <Card>
                    <CardHeader onClick={() => this.showHide()}>
                        <Row className="align-items-center">
                            <Col className="col-md-11 text-left">
                                <h3>Import Contacts</h3>
                            </Col>
                            <Col xs="1" className="text-right">
                                {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.open}>
                        <CardBody>
                            {(!this.state.isDone) ?
                                <>
                                    <Row className="align-items-center">
                                        <Col className="col-md-6 text-left">
                                            <Input type="file" name="file" accept='.csv' onChange={e => this.handleUpload(e)} value="" />
                                        </Col>
                                        <Col className="col-md-6 text-right">
                                            Imports a contacts .csv
                                            <p><a href="/crm-contacts-template.csv" download>Download CSV Template</a></p>
                                        </Col>
                                    </Row>
                                </> : <></>
                            }
                            {this.state.error &&
                                <Row>
                                    <Col className="text-left text-danger">
                                        {this.state.error}
                                    </Col>
                                    <Col className="text-right">
                                        <Button color="primary" onClick={this.resetUpload}>Import Another</Button>
                                    </Col>
                                </Row>
                            }
                            {this.state.results && this.state.results.incompleteCompanies &&
                                <Row>
                                    <Col className="text-left">
                                        <p>To complete importing contacts, please identify any missing company information (entries without both fields will not be added):</p>
                                        <Row className='font-weight-bold'>
                                            <Col xs={6}>
                                                Company Name
                                            </Col>
                                            <Col>
                                                Company Number
                                            </Col>
                                        </Row>
                                        {this.state.results.incompleteCompanies.map((company, companyIndex) => (
                                            <Row className='mt-2'>
                                                <Col xs={6}>
                                                    <Input
                                                        className={duplicates.findIndex(item => item === company.secNumber) > -1 ? "border border-danger" : (this.state.results.incompleteCompanies[companyIndex].companyName !== '' && this.state.results.incompleteCompanies[companyIndex].secNumber !== '' ? 'border border-success' : '')}
                                                        onChange={(e) => this.changeIncompleteCompany(e.target.value, companyIndex, 'companyName')}
                                                        value={company.companyName}
                                                    />
                                                </Col>
                                                <Col className='pr-1'>
                                                    <Input
                                                        className={duplicates.findIndex(item => item === company.secNumber) > -1 ? "border border-danger" : (this.state.results.incompleteCompanies[companyIndex].companyName !== '' && this.state.results.incompleteCompanies[companyIndex].secNumber !== '' ? 'border border-success' : '')}
                                                        onChange={(e) => this.changeIncompleteCompany(e.target.value, companyIndex, 'secNumber')}
                                                        value={company.secNumber}
                                                    />
                                                </Col>
                                                <Col xs={2} className='pl-1'>
                                                    {company.secNumber === '' &&
                                                        <Button color="secondary" onClick={() => this.autoGenerate(companyIndex)}>Auto Generate</Button>}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                    <Col className="text-right" xs={2}>
                                        <Button disabled={duplicates.length > 0} color="primary" onClick={this.finishUpload}>Finish Import</Button>
                                    </Col>
                                </Row>
                            }
                            {this.state.results && !this.state.results.incompleteCompanies &&
                                <Row>
                                    <Col className="text-left">
                                        <p>New contacts added to database: <strong>{(this.state.results?.unmatchedContacts?.length || 0) + (this.state.results?.missingSecIDContacts?.length || 0)}</strong></p>
                                        <p>Existing contacts in database: <strong>{this.state.results?.matchedContacts?.length || 0}</strong></p>
                                        {/* <p>Companies not in database: <strong>{this.state.results?.missingSecIDs?.length || 0}</strong></p> */}
                                        <p>Contacts not associated with a company: <strong>{this.state.results?.missingSecIDContacts?.length || 0}</strong></p>
                                    </Col>
                                    <Col className="text-right">
                                        <Button color="primary" onClick={this.resetUpload}>Import Another</Button>
                                    </Col>
                                </Row>
                            }
                        </CardBody>
                    </Collapse>
                </Card>
            </Container>
        );
    }
}

export default ImportContacts;